import { FormTabs } from '@dreryk/react-components';

import { VisitFormBean } from '../visitForm.types';

import { VisitFormTabsId } from './VisitFormTabs.types';

type VisitFormTabsChangeTabChildrenRenderProps = {
   changeTab: (tabId: VisitFormTabsId) => void;
};

type VisitFormTabsChangeTabProps = {
   children: (renderProps: VisitFormTabsChangeTabChildrenRenderProps) => JSX.Element | null;
};

export const VisitFormTabsChangeTab = (props: VisitFormTabsChangeTabProps): JSX.Element | null => {
   const changeTab = FormTabs.useChangeTab<VisitFormBean, VisitFormTabsId>();

   return props.children({ changeTab: changeTab });
};
